import {
  ManageSharingSection,
  DetailSection,
  ViewLayout,
  AdvanceStack,
} from '../components';
import { RibbonBar, RibbonDivider } from 'common/components';

import { ManipulateTransitionPageGridSection } from './components';

const TransitionPage = () => {
  return (
    <RibbonBar>
      <ManageSharingSection />
      <DetailSection />
      <ViewLayout disabled />
      <RibbonDivider />
      <ManipulateTransitionPageGridSection />
      <RibbonDivider />
      <AdvanceStack isDisabled />
    </RibbonBar>
  );
};

export default TransitionPage;
